import { createContext, useContext } from 'react';

// Provides the current course slug to editor components that need course-specific rendering.
// Value is a course slug string (e.g. 'mcat', 'lsat') or null when outside a course context.
const CourseContext = createContext(null);
export default CourseContext.Provider;
export function useCourseContext() {
  return useContext(CourseContext);
}
